import { Flexbox } from '@components/styles/mixins/Flexbox.styled';
import styled from 'styled-components';

export const Splash = styled.section`
    width:100vw;
    height:90vh;
    ${Flexbox({justifyContent:"center", alignItems:"center", flexDirection:"column"})};
    .loading{
        ${Flexbox({justifyContent:"center", alignItems:"center", flexDirection:"column"})};
    }
    row-gap:1.4rem;
    img{
        height:5rem;
    }
    text-align:center;
    font-size:2rem;
    @media all and (max-width: ${({ theme }) => theme.breakpoints.breakpoint1}) {
        img{
            height:2.5rem;
        }
        font-size:1rem;
    }
`;